import { CONFIG } from '../../../../config'
import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/dashboard/produtividade-expedicao`

const ProdutividadeExpedicaoHttp = {
  async getExpedicoesPorEmpresa(companyId, tpId, pInicial, pFinal) {
    try {
      const url =
        BASE_URL +
        '/expedicoes' +
        `?tp_id=${tpId}&company_id=${companyId}&pInicial=${pInicial}&pFinal=${pFinal}`
      const response = await authHttp().get(url)
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },
}

export default ProdutividadeExpedicaoHttp
